import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  default_item_name: Yup.string().trim().required('msg_error_required_field'),
  default_amount: Yup.string().trim().required('msg_error_required_field'),
  default_price: Yup.string().trim().required('msg_error_required_field'),
});
